// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Центр документів» (Documents, ключ `document`, група `basic`). */
export const documentsManifest: IModuleManifest = {
  key: 'document',
  group: 'basic',
  slug: 'documents',
  prefix: 'DOC',
  name: { en: 'Documents', uk: 'Центр документів' },
  entities: [
    { key: 'document', slug: 'document', name: { en: 'Documents', uk: 'Центр документів' }, main: true },
    { key: 'document_version', slug: 'document-version', name: { en: 'Document Versions', uk: 'Версії' }, main: false },
    { key: 'document_signer', slug: 'document-signer', name: { en: 'Document Signers', uk: 'Підписанти' }, main: false },
    { key: 'document_review', slug: 'document-review', name: { en: 'Document Reviews', uk: 'Ознайомлення з документами' }, main: false },
    { key: 'document_template', slug: 'document-template', name: { en: 'Document Templates', uk: 'Шаблони документів' }, main: false },
    { key: 'document_status', slug: 'document-status', name: { en: 'Document Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/documentsSlice').then((m) => m.documentsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
